module.exports = __webpack_public_path__ + "img/hells_portal_small.b6c9c5fd.png";